import { routerFrom } from "router";

export const routes = [
  {
    acl: [],
    label: "Deleted Account",
    name: "deleted-account",
    path: "/deleted-account",
  },
  {
    acl: [],
    label: "Converted Account",
    name: "converted-account",
    path: "/converted-account",
  },
  {
    acl: [],
    label: "Logout",
    name: "logout",
    path: "/logout",
    testName: "logout",
  },
  {
    acl: [],
    label: "agreement",
    name: "agreement",
    path: "/agreement/:pathName",
  },
  {
    acl: [],
    label: "oauth",
    name: "oauth",
    path: "/social/:pathName",
  },
  {
    acl: [],
    label: "auth",
    name: "auth",
    path: "/auth",
  },
  {
    acl: [],
    label: "Login",
    name: "login",
    path: "/auth?tab=login",
  },
  {
    acl: [],
    label: "Sign Up",
    name: "sign-up",
    path: "/auth?tab=register",
  },
  {
    acl: [],
    label: "Sign Up Form",
    name: "register-form",
    path: "/auth?tab=registerForm",
  },
  {
    acl: [],
    label: "Verify Email",
    name: "register-email-verify",
    path: "/register-email-verify",
  },
  {
    acl: [],
    label: "Password Reset",
    name: "password-reset",
    path: "/password/reset",
  },
  {
    acl: [],
    label: "Password Setup",
    name: "password-setup",
    path: "/password/setup",
  },
  {
    acl: [],
    label: "Email Confirmation",
    name: "email-confirmation",
    path: "/email-confirmation",
  },
  {
    acl: [],
    label: "Unsubscribe",
    name: "unsubscribe",
    path: "/unsubscribe",
  },
];

export const router = routerFrom(routes);
